import { useRef, useState } from 'react';
import { MEDIA_FILE_ACCEPT } from './mediaFormats';
import './FilePicker.css';

export default function FilePicker({ disabled, file, onSelect }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const choose = (files) => {
    if (files?.[0]) void onSelect(files[0]);
  };

  return (
    <div
      className={`drop-zone ${dragging ? 'dragging' : ''} ${file ? 'has-file' : ''} ${disabled ? 'disabled' : ''}`}
      onDragEnter={(event) => { event.preventDefault(); setDragging(true); }}
      onDragLeave={(event) => { event.preventDefault(); setDragging(false); }}
      onDragOver={(event) => event.preventDefault()}
      onDrop={(event) => { event.preventDefault(); setDragging(false); choose(event.dataTransfer.files); }}
      onClick={!disabled ? () => inputRef.current?.click() : undefined}
    >
      <input
        ref={inputRef}
        type="file"
        hidden
        disabled={disabled}
        accept={MEDIA_FILE_ACCEPT}
        onChange={(event) => choose(event.target.files)}
        aria-label="Selecciona un fitxer d’àudio o vídeo"
      />
      {file ? (
        <>
          <div className="drop-zone-icon success" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 12l2 2 4-4" /><circle cx="12" cy="12" r="10" />
            </svg>
          </div>
          <div className="drop-zone-text">
            <strong className="file-name">{file.name}</strong>
            <button className="file-uploader-change-button" type="button" disabled={disabled} onClick={(event) => { event.stopPropagation(); inputRef.current?.click(); }}>Canvia el fitxer</button>
          </div>
        </>
      ) : (
        <>
          <div className="drop-zone-icon" aria-hidden="true">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M12 15V3m0 0l-4 4m4-4l4 4" />
              <path d="M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17" />
            </svg>
          </div>
          <div className="drop-zone-text">
            <span className="drop-zone-main">Arrossega un fitxer d'àudio o vídeo aquí</span>
            <span className="drop-zone-or">o</span>
            <button className="file-uploader-select-button" type="button" disabled={disabled} onClick={(event) => { event.stopPropagation(); inputRef.current?.click(); }}>Selecciona un fitxer</button>
          </div>
          <span className="drop-zone-formats">MP3, WAV, M4A, MPEG, FLAC, OGG, OPUS i més</span>
        </>
      )}
    </div>
  );
}
